import React, { useState } from 'react'
import { SelectAction, SelectActionWithValue } from '../CommonComponents'
import {
  AllAcceptOrRejectActionType,
  AllMinimumCrateItemsActionType,
  Config,
  CrateAction,
  MinimumCrateItemsActionType,
} from '../../../domain/Assortment'
import { FormLayout } from 'styles/FormLayout'
import { CrateActionSnapshot, DisabledCrateActions } from './CrateActionDialog'

type Props = {
  config: Config
  id: string
  snapshot: CrateActionSnapshot
  disabled: DisabledCrateActions
  onApply: (id: string, snapshot: CrateActionSnapshot) => void
}

export const ModifyAllDialog = ({ config, id, snapshot, disabled, onApply }: Props) => {
  const [allMinimumCrateItemsAction, setAllMinimumCrateItemsAction] = useState<CrateAction | undefined>(
    snapshot.allMinimumCrateItemsAction,
  )
  const [allAcceptOrRejectAction, setAllAcceptOrRejectAction] = useState<CrateAction | undefined>(
    snapshot.allAcceptOrRejectAction,
  )

  return (
    <div className="card">
      <FormLayout.Content>
        <h3 className="text-lg mb-md">Action All</h3>
        <SelectActionWithValue
          config={config}
          label={'Minimum crate items:'}
          type={allMinimumCrateItemsAction?.type ?? 'UNSET'}
          disabled={disabled.allMinimumCrateItemsAction}
          showDisabled={false}
          value={allMinimumCrateItemsAction?.value ?? ''}
          allowOverride={allMinimumCrateItemsAction?.allowOverride}
          options={[AllMinimumCrateItemsActionType.SET_MINIMUM_NUMBER_OF_ITEMS_ALL]}
          maxValue={30}
          onTypeChanged={(typeValue) =>
            setAllMinimumCrateItemsAction({
              ...allMinimumCrateItemsAction,
              type: typeValue as MinimumCrateItemsActionType,
            })
          }
          onAllowOverrideChanged={(allow) => {
            if (allMinimumCrateItemsAction) {
              setAllMinimumCrateItemsAction({ ...allMinimumCrateItemsAction, allowOverride: allow })
            }
          }}
          onValueChanged={(value: string) => {
            if (allMinimumCrateItemsAction) {
              setAllMinimumCrateItemsAction({ ...allMinimumCrateItemsAction, value: value })
            }
          }}
        />
        <SelectAction
          label={'Accept/Reject All:'}
          type={allAcceptOrRejectAction?.type ?? 'UNSET'}
          disabled={disabled.allAcceptOrRejectAction}
          showDisabled={false}
          allowOverride={allAcceptOrRejectAction?.allowOverride}
          options={[
            AllAcceptOrRejectActionType.SET_ACCEPT_ALL,
            AllAcceptOrRejectActionType.SET_REJECT_ALL,
            AllAcceptOrRejectActionType.CLEAR,
          ]}
          onTypeChanged={(typeValue) =>
            setAllAcceptOrRejectAction({ ...allAcceptOrRejectAction, type: typeValue as AllAcceptOrRejectActionType })
          }
          onAllowOverrideChanged={(allow) => {
            if (allAcceptOrRejectAction) {
              setAllAcceptOrRejectAction({ ...allAcceptOrRejectAction, allowOverride: allow })
            }
          }}
        />
        <FormLayout.FooterContainer>
          <FormLayout.Footer>
            <button
              className="btn btn-primary-dark py-sm"
              onClick={() => {
                onApply(id, {
                  allMinimumCrateItemsAction: allMinimumCrateItemsAction,
                  allAcceptOrRejectAction: allAcceptOrRejectAction,
                })
              }}
            >
              <span>Save</span>
            </button>
          </FormLayout.Footer>
        </FormLayout.FooterContainer>
      </FormLayout.Content>
    </div>
  )
}
